if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.events?.abort(); this.events = new AbortController();
      this.refreshElements();
      this.setAttribute('data-cn-gallery', '');
      this.addEventListener('click', event => {
        if (this.ignoreClick && event.target.closest('.product__modal-opener')) { event.preventDefault(); event.stopImmediatePropagation(); this.ignoreClick = false; return; }
        const previous = event.target.closest('[data-cn-media-prev]'), next = event.target.closest('[data-cn-media-next]');
        if (previous || next) { this.navigate(previous ? -1 : 1); return; }
        const thumbnail = event.target.closest('[data-target]');
        if (thumbnail && event.target.closest('button')) this.setActiveMedia(thumbnail.dataset.target, false);
      }, { signal: this.events.signal, capture: true });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.matches('input,textarea,select')) return;
        event.preventDefault(); this.navigate(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal: this.events.signal });
      this.elements.viewer?.addEventListener('pointerdown', event => {
        this.ignoreClick = false;
        if (event.pointerType === 'touch') this.touch = { x: event.clientX, y: event.clientY };
      }, { signal: this.events.signal });
      this.elements.viewer?.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x, dy = event.clientY - this.touch.y; this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { this.ignoreClick = true; this.navigate(dx < 0 ? 1 : -1); }
      }, { signal: this.events.signal });
      this.elements.viewer?.addEventListener('pointercancel', () => { this.touch = null; }, { signal: this.events.signal });
      const active = this.items.find(item => item.classList.contains('is-active')) || this.items[0];
      if (active) this.setActiveMedia(active.dataset.mediaId, false, false);
    }

    disconnectedCallback() { this.events?.abort(); this.touch = null; }
    refreshElements() { this.elements = { liveRegion: this.querySelector('[id^="GalleryStatus"]'), viewer: this.querySelector('[id^="GalleryViewer"]'), thumbnails: this.querySelector('[id^="GalleryThumbnails"]') }; }
    get items() { return [...(this.elements.viewer?.querySelectorAll('li[data-media-id]') || [])]; }
    navigate(direction) {
      const items = this.items; if (!items.length) return;
      const index = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
      this.setActiveMedia(items[(index + direction + items.length) % items.length].dataset.mediaId, false);
    }
    setActiveMedia(mediaId, _prepend = false, announce = true) {
      this.refreshElements();
      const items = this.items, active = items.find(item => item.dataset.mediaId === mediaId) || items[0];
      if (!active) return;
      items.forEach(item => { item.classList.toggle('is-active', item === active); item.setAttribute('aria-hidden', String(item !== active)); });
      this.querySelectorAll('[data-target] button').forEach(button => button.removeAttribute('aria-current'));
      const thumbnail = [...this.querySelectorAll('[data-target]')].find(item => item.dataset.target === active.dataset.mediaId);
      thumbnail?.querySelector('button')?.setAttribute('aria-current', 'true');
      const thumbnailList = thumbnail?.parentElement;
      if (thumbnailList?.clientWidth > 0) {
        if (thumbnail.offsetLeft < thumbnailList.scrollLeft) thumbnailList.scrollLeft = thumbnail.offsetLeft;
        else if (thumbnail.offsetLeft + thumbnail.offsetWidth > thumbnailList.scrollLeft + thumbnailList.clientWidth) thumbnailList.scrollLeft = thumbnail.offsetLeft + thumbnail.offsetWidth - thumbnailList.clientWidth;
      }
      const index = items.indexOf(active);
      const counter = this.querySelector('[data-cn-media-count]'); if (counter) counter.textContent = `${index + 1} / ${items.length}`;
      this.querySelectorAll('[data-cn-media-prev],[data-cn-media-next]').forEach(button => { button.disabled = items.length < 2; button.hidden = items.length < 2; });
      if (announce && this.elements.liveRegion) this.elements.liveRegion.textContent = `Produktbild ${index + 1} von ${items.length}`;
      if (announce) this.playActiveMedia(active);
    }
    setActiveThumbnail(thumbnail) {
      this.querySelectorAll('[data-target] button').forEach(button => button.removeAttribute('aria-current'));
      thumbnail?.querySelector('button')?.setAttribute('aria-current', 'true');
    }
    playActiveMedia(activeItem) { window.pauseAllMedia?.(); activeItem.querySelector('deferred-media,product-model')?.loadContent?.(false); }
  });
}
